import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(`--> ${request.method}: '${request.url}'`);
    const start = Date.now();
    return next.handle(request).pipe(tap(x => {
      if (x instanceof HttpResponse) {
        const end = Date.now() - start;
        console.log(`<-- ${request.method}: '${request.url}', took: ${end} ms, status: ${x.status} ${x.statusText}`);
      }
      return x;
    }));
  }
}
